import { render, staticRenderFns } from "./NotificationPane.vue?vue&type=template&id=6888e38d&"
import script from "./NotificationPane.vue?vue&type=script&lang=js&"
export * from "./NotificationPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports